// HealthBanner — 処理パイプライン死活の常時表示 (blueprint v2 Phase 0, 2026-07-04)
//   /api/health/pipeline を60秒毎にpollし、異常時のみ全ページ共通ヘッダ直下にバナー表示。
//   「送ったのに何も起きない」無音を、観測可能な警告に置換する第一歩。
import React, { useEffect, useState } from 'react';
import { fetchHealthPipeline, PipelineHealth } from '../api/client';

export const HealthBanner: React.FC = () => {
  const [h, setH] = useState<PipelineHealth | null>(null);
  useEffect(() => {
    let alive = true;
    const tick = () => fetchHealthPipeline().then((r) => { if (alive) setH(r); }).catch(() => { if (alive) setH(null); });
    tick();
    const t = setInterval(tick, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);
  if (!h) return null;
  const warns: string[] = [];
  if (h.batches.attention > 0) warns.push(`対応待ち(要修正)のバッチ ${h.batches.attention}件 (登録失敗/照合不一致/停滞)`);
  if (h.sweep.stale && h.batches.open > 0) warns.push('照合スイープが15分以上動いていません');
  if (warns.length === 0) return null;
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 10, padding: '7px 16px',
      background: '#fdf3e3', borderBottom: '1px solid #e3c68a', color: '#a46a12',
      fontSize: 12, fontWeight: 700,
    }}>
      <span aria-hidden style={{ fontWeight: 900 }}>!</span>
      {warns.join(' ／ ')}
      <a href="#batches" style={{ marginLeft: 'auto', color: '#7a5312', fontWeight: 800, whiteSpace: 'nowrap' }}>バッチ台帳を確認 →</a>
    </div>
  );
};

export default HealthBanner;
